module.exports = __webpack_public_path__ + "img/WAVES.77869a46.svg";